import React from "react";

const gradingOptions = [
  "",
  "Mint (M)",
  "Near Mint (NM or M-)",
  "Very Good Plus (VG+)",
  "Very Good (VG)",
  "Good Plus (G+)",
  "Good (G)",
  "Fair (F)",
  "Poor (P)",
];

export default function GradingForm({
  mediaCondition,
  setMediaCondition,
  sleeveCondition,
  setSleeveCondition,
  inlayCondition,
  setInlayCondition,
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
      {[
        {
          label: "Media Condition",
          value: mediaCondition,
          onChange: setMediaCondition,
        },
        {
          label: "Sleeve Condition",
          value: sleeveCondition,
          onChange: setSleeveCondition,
        },
        {
          label: "Inlay Condition",
          value: inlayCondition,
          onChange: setInlayCondition,
        },
      ].map(({ label, value, onChange }) => (
        <div key={label}>
          <label className="block text-sm font-semibold text-zinc-300 mb-1">
            {label}
          </label>
          <select
            className="bg-zinc-800 text-zinc-100 border border-zinc-600 rounded px-4 py-2 w-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          >
            {gradingOptions.map((option) => (
              <option key={option} value={option}>
                {option || "Select..."}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
}
